import {mapState} from 'pinia';
import {useAuthStore} from '@store';
import {fullName, initials, isAgent, isBroker, isMigrated, isBrokerOwner, isLinkedToCompany, isSeller, isTC} from '@helpers/user';
import {connectionStatus, CONNECTION_ACCEPTED} from '@helpers/connections';
import _ from 'lodash';
import PusherMixin from '@mixins/PusherMixin';
export default {
    mixins:[
        PusherMixin
    ],
    data: () => ({
        connections: []
    }),
    computed: {
        ...mapState(useAuthStore, {
            me: 'me',
            clientUuid: 'clientUuid',
            thirdPartyUuid: 'thirdPartyUuid',
            loggedIn: 'loggedIn'
        }),
        isAgent() {
            return isAgent(this.me);
        },
        isSeller() {
            return isSeller(this.me);
        },
        isBroker() {
            return isBroker(this.me);
        },
        isTC(){
            return isTC(this.me);
        },
        isMigrated() {
            return isMigrated(this.me);
        },
        isBrokerOwner() {
            return isBrokerOwner(this.me);
        },
        isLinkedToCompany() {
            return isLinkedToCompany(this.me);
        },
        fullName() {
            return fullName(this.me);
        },
        initials() {
            return initials(this.me);
        },
        owner() {
            return this.isBroker ? 'broker' : this.isAgent ? 'agent' : 'seller';
        },
        connected(){
            if(this.isAgent || this.isTC){
                return _.filter(this.connections, c =>{
                    return [CONNECTION_ACCEPTED].includes(connectionStatus(c.attributes));
                }).length > 0;
            }
            return false;
        }
    },
    methods:{
        async refreshConnections(){
            if(this.isAgent || this.isTC){
                this.connections = await this.me.getConnections();
            }
        },
    },
    async created(){
        await this.refreshConnections();
        if(this.isAgent || this.isTC){
            this.subscribePusherChannel(
                `connections.${this.me.uuid}`,
                {
                    'updated': async(data) => {
                        await this.refreshConnections();
                    }
                }
            );
        }
    },
    beforeDestroy(){
        if(this.isAgent || this.isTC){
            this.unsubscribePusherChannel(`connections.${this.me.uuid}`);
        }        
    }
};
